import { initializeApp, getApp, getApps, type FirebaseApp } from "firebase/app";
import { getFirestore, type Firestore } from "firebase/firestore";

/**
 * Firebase Configuration
 * Using import.meta.env for Vite-based projects.
 */
interface FirebaseConfig {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId?: string;
}

const firebaseConfig: FirebaseConfig = {
    apiKey: "AIzaSyCyxMEKqGiL4URtjm46cE6uUJ-shMR7nig",
    authDomain: "leykilo.firebaseapp.com",
    projectId: "leykilo",
    storageBucket: "leykilo.firebasestorage.app",
    messagingSenderId: "821363719977",
    appId: "1:821363719977:web:c61d285cb765d7be944138",
    measurementId: "G-F5VRTFHST3"
};

// Initialize Firebase only once
const app: FirebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Initialize Firestore only from the singleton app
export const db: Firestore = getFirestore(app);

export default app;